// 请求的地址
let path = 'https://flash-api.ushknews.com/'
let proxy = path

if (process.env.NODE_ENV === 'development') {
  // 接口转发
  proxy = '/api/'
}

let calendarProxy = 'https://calendar-api.ushknews.com/'
if (process.env.NODE_ENV === 'development') {
  // 接口转发
  calendarProxy = '/calendar-api/'
}
/**
 * 请求url
 */
export const requestUrl = {
  ucenterInfo: '//ucenter.jin10.com/info/',
  video: {
    getProxy (url) {
      var proxy = process.env.NODE_ENV === 'development' ? '//cdn.jin10.com/reading/uploads/' : '//cdn.jin10.com/reading/uploads/'
      return proxy + url
    },
    list (page, type) {
      /*
       *美港电讯 :  https://cdn.jin10.com/reading/uploads/ushkmessage.json?v=1527050633382
       * 头条  https://cdn.jin10.com/reading/uploads/daynews.json?v=1527050633382
       */
      return this.getProxy('video_list' + '.json') + '?v=' + (new Date()).getTime()
    },
    getEffect (id) {
      return this.getProxy(id + '/' + id + '_effect.jpeg')
    }
  },
  home: {
    flash: proxy + 'flash',
    company: proxy + 'company'
  },
  rili: {
    economics: calendarProxy + 'rili',
    stock: calendarProxy + 'rili?type=1',
    events: calendarProxy + 'events',
    holiday: calendarProxy + 'holidays',
    stockAffect: calendarProxy + 'web/api/stock_affect'
  }
}



// WEBPACK FOOTER //
// ./src/commons/config.js